import React from 'react';

const Api = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3ZM4 5V19H20V5H4ZM20 12L16.464 15.536L15.05 14.121L17.172 12L15.05 9.879L16.464 8.464L20 12ZM6.828 12L8.95 14.121L7.536 15.536L4 12L7.536 8.464L8.95 9.88L6.828 12ZM11.244 17H9.116L12.756 7H14.884L11.244 17Z"
      fill="#0073F7"
    />
  </svg>
);

export default Api;
